import type { MutableState } from '../State';
import { PetSpeciesID } from '../pet';
import { SpeciesState } from './encyclopedia.schema';

export function setSpeciesState(
  mutableState: MutableState,
  species: PetSpeciesID,
  state: SpeciesState,
): void {
  const { encyclopedia } = mutableState;
  const currentState = encyclopedia.speciesState[species];

  // Already unlocked, do nothing.
  if (currentState === 'unlocked') return;
  // Cannot veil an unveiled species, do nothing.
  if (currentState === 'unveiled' && state === 'veiled') return;

  encyclopedia.speciesState[species] = state;

  // Unlocking or unveiling a species, set notification.
  if (state === 'unlocked' || state === 'unveiled') {
    encyclopedia.speciesNotification[species] = true;
  }
}
